module.exports = __webpack_public_path__ + "static/media/team-1.fc79efc9.jpg";